module.exports = __webpack_public_path__ + "img/tram-purple.94606bed.svg";